<div class="selfservice-page-container" *ngIf="!isLoadingAvailableCustomers && !isLoadingLabels">
	<div class="header-container">
		<div class="title">
			<span (click)="emitLeavePage()">< {{ labels.lbl_geral_inicio }} </span>
		</div>
		<div class="register-navigation">
			<div
				class="navigation-interactive"
				(click)="
					selfserviceQuestionArray.length > 0
						? selfserviceView.lastAvailableStep === selfserviceView.selfserviceDetailment
							? (selfserviceView.actualStep = selfserviceView.selfserviceQuestions)
							: ''
						: null
				">
				<span
					class="ball filled"
					[ngClass]="{
						selected:
							selfserviceView.actualStep === selfserviceView.selfserviceQuestions ||
							selfserviceView.actualStep === selfserviceView.selfservicePrePhase,
					}"
					><fa-icon [icon]="faIcon.faHandPointUp"></fa-icon
				></span>
				<span
					[ngClass]="{
						selected:
							selfserviceView.actualStep === selfserviceView.selfserviceQuestions ||
							selfserviceView.actualStep === selfserviceView.selfservicePrePhase,
					}"
					>{{ labels.lbl_geral_autoatendimento }}</span
				>
			</div>
			<div
				class="line"
				[ngClass]="{
					loading50: selfserviceView.lastAvailableStep > selfserviceView.selfservicePrePhase,
					loading100: selfserviceView.lastAvailableStep >= selfserviceView.selfserviceDetailment,
				}"></div>
			<div
				class="navigation-interactive"
				(click)="
					selfserviceView.lastAvailableStep === selfserviceView.selfserviceDetailment
						? (selfserviceView.actualStep = selfserviceView.selfserviceDetailment)
						: ''
				">
				<span
					class="ball"
					[ngClass]="{
						filled: selfserviceView.lastAvailableStep >= selfserviceView.selfserviceDetailment,
						selected: selfserviceView.actualStep === selfserviceView.selfserviceDetailment,
					}"
					><fa-icon [icon]="faIcon.faNewspaper"></fa-icon
				></span>
				<span [ngClass]="{ selected: selfserviceView.actualStep === selfserviceView.selfserviceDetailment }">{{
					labels.lbl_geral_detalhamento
				}}</span>
			</div>
			<div class="line" [ngClass]="{ loading100: selfserviceView.lastAvailableStep >= selfserviceView.selfserviceEnd }"></div>
			<div class="navigation-interactive">
				<span
					class="ball"
					[ngClass]="{
						filled: selfserviceView.lastAvailableStep >= selfserviceView.selfserviceEnd,
						selected: selfserviceView.actualStep === selfserviceView.selfserviceEnd,
					}"
					><fa-icon [icon]="faIcon.faCheck"></fa-icon
				></span>
				<span [ngClass]="{ selected: selfserviceView.actualStep === selfserviceView.selfserviceEnd }">{{
					labels.lbl_geral_criado
				}}</span>
			</div>
		</div>
	</div>

	<div class="content-container" *ngIf="selfserviceView.actualStep === selfserviceView.selfservicePrePhase">
		<div class="available-customer-container">
			<cpi-input-with-autocomplete
				[availableOptions]="availableCustomerIAC"
				[placeholder]="labels.lbl_geral_buscar + ' - ' + labels.lbl_geral_cliente"
				[inputHeight]="'30px'"
				[minInputLength]="0"
				[setValue]="requestOpeningOptions.id_customer"
				(onValueChange)="setCustomer($event)">
			</cpi-input-with-autocomplete>
		</div>

		<ng-container *ngIf="!isLoadingAvailableUsers && !isLoadingCustomerPermission && requestOpeningOptions.id_customer !== ''">
			<span class="label">{{ labels.lbl_para_quem }}</span>
			<cpi-input-with-autocomplete
				[availableOptions]="availableUsersIAC"
				[placeholder]="labels.lbl_search_person"
				[inputHeight]="'30px'"
				(onValueChange)="requestOpeningOptions.id_enduser = $event"
				(getInputText)="requestOpeningOptions.enduser = $event">
			</cpi-input-with-autocomplete>
		</ng-container>

		<cpi-dot-bounce-loading-effect
			[color]="'var(--primary-color-1)'"
			*ngIf="isLoadingAvailableUsers || isLoadingCustomerPermission"></cpi-dot-bounce-loading-effect>

		<div class="button-container">
			<button
				[disabled]="
					requestOpeningOptions.id_customer === '' ||
					requestOpeningOptions.id_enduser === '' ||
					isLoadingAvailableUsers ||
					isLoadingCustomerPermission
				"
				(click)="
					selfserviceView.actualStep = selfserviceView.selfserviceQuestions;
					selfserviceView.lastAvailableStep = selfserviceView.selfserviceQuestions;
					getFirstQuestion(requestOpeningOptions.id_customer)
				">
				{{ labels.lbl_geral_continuar }}
			</button>
		</div>
	</div>

	<div class="content-container" *ngIf="!isLoadingNextQuestion && selfserviceView.actualStep === selfserviceView.selfserviceQuestions">
		<div class="question">
			<span (click)="getPreviousQuestion()" *ngIf="selfserviceQuestionMemory.length >= 1">
				<fa-icon [icon]="faIcon.faArrowLeft"></fa-icon>
			</span>
			{{ selfserviceQuestionMemory.length === 0 ? labels.lbl_lets_start_what_is_your_request : selfserviceQuestionArray[0].question }}
		</div>

		<div class="informative-box" *ngIf="selfserviceQuestionArray[0]?.informative">
			{{ selfserviceQuestionArray[0]?.informative }}
		</div>

		<div class="selfservice-card-container">
			<ng-container *ngFor="let selfserviceCard of selfserviceQuestionArray">
				<div class="selfservice-card" *ngIf="selfserviceCard.classificationRestricted != 1" (click)="handleClick(selfserviceCard)">
					<span>{{ selfserviceCard.response ? selfserviceCard.response : selfserviceCard.category }}</span>
					<span class="card-icon" *ngIf="selfserviceCard.iconResponse || selfserviceCard.iconCategory">
						<fa-icon
							[icon]="
								selfserviceCard.iconResponse
									? faIcon[selfserviceCard.iconResponse]
										? faIcon[selfserviceCard.iconResponse]
										: faIcon.faGlobe
									: selfserviceCard.iconCategory
										? faIcon[selfserviceCard.iconCategory]
											? faIcon[selfserviceCard.iconCategory]
											: faIcon.faGlobe
										: faIcon.faGlobe
							"></fa-icon
					></span>
				</div>
			</ng-container>
			<div
				class="selfservice-card"
				(click)="setNoTemplateRequest()"
				*ngIf="requestOpeningOptions.REQUEST_OPENING_no_other == true && selfserviceQuestionMemory.length === 0">
				{{ labels.lbl_asset_other }}
			</div>
		</div>
	</div>

	<div
		class="content-container"
		*ngIf="
			(!isLoadingNextQuestion && selfserviceView.actualStep === selfserviceView.selfserviceDetailment) ||
			selfserviceView.actualStep === selfserviceView.selfserviceEnd
		">
		<pcp-request-opening
			[requestTemplateId]="requestTemplateId"
			[resetDetailment]="resetDetailmentBool"
			[options]="requestOpeningOptions"
			(newRequestCreated)="requestOpened()">
		</pcp-request-opening>
	</div>

	<div class="is-loading-selfservice" *ngIf="isLoadingNextQuestion">
		<cpi-svg-gears></cpi-svg-gears>
		<div>{{ labels.lbl_edocs_carregando }}!</div>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingAvailableCustomers || isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
